<template>
  <error-page
    textSubtitle='Página no encontrada'
    :listErrorComponent='listErrorComponents'
  />
</template>

<script>
import ErrorPage from './ErrorPage.vue';

export default {
  name: 'Error404',
  components: { ErrorPage },
  data () {
    return {
      listErrorComponents: [
        {
          id: 1,
          title: 'Pagina principal ',
          hrefLink: '#',
          target: '_top'
        }
      ]
    };
  }
};
</script>
